import { render } from "./PlpGridViewContainer.vue?vue&type=template&id=8b193dc8"
import script from "./PlpGridViewContainer.vue?vue&type=script&lang=js"
export * from "./PlpGridViewContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__